<template>
  <div
    class="flex flex-col mb-4 mr-4  justify-start bg-black shadow-lg overflow-hidden preview-image-h preview-image-w relative border border-black"
  >
    <div
      class="absolute bg-white items-center overflow-hidden h-16 preview-image-w opacity-75 p-2"
      style="margin-top:auto;bottom:0px"
    >
      <div class="flex flex-col">
        <div class="flex flex-row justify-start">
          <router-link
            :to="{name:'excercisesDetails',params:{key:shortKey}}"
            class="flex-grow overflow-hidden"
          >
            <span class="overflow-hidden text-lg font-bold flex-grow tracking-wider">{{ title }}</span>
          </router-link>
          <i
            v-if="showRemoveButton"
            class="far fa-trash-alt cursor-pointer mr-2"
            @click="onRemove()"
          />
          <i
            v-if="showAddButton"
            class="fas fa-plus-circle mr-5 cursor-pointer"
            @click="onAddClicked(shortKey)"
          />
          <router-link
            v-if="showOpenButton"
            target="_blank"
            :to="{ name: 'excercisesDetails', params: { key: shortKey } }"
          >
            <i class="fas  fa-external-link-alt" />
          </router-link>
        </div>
        <TagList
          :tags="tags"
          @tagClicked="onTagClicked()"
        />
      </div>
    </div>

    <div class="flex flex-col bg-black h-full">
      <router-link class="h-full"
        :to="{name:'excercisesDetails',params:{key:shortKey}}"
      >
        <sc-media-image
          v-if="!preferedPreviewMedia || preferedPreviewMedia.kind!=7 || !preferedPreviewMedia.value"
          :image-id="image"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import TagList from '../tagList'

export default {
    name: 'ExerciseSmall',
    components: { TagList },
    props: {
        tagsClickable: {
            type: Boolean,
            required: false
        },
        preferedPreviewMedia: {
            type: Object,
            required: false
        },
        title: {
            type: String,
            required: false
        },
        image: {
            type: String,
            required: false
        },
        shortKey: {
            type: String,
            required: false
        },
        tags: {
            type: Array,
            required: false
        },
        showRemoveButton: {
            type: Boolean,
            required: false
        },
        showAddButton: {
            type: Boolean,
            required: false
        },
        showOpenButton: {
            type: Boolean,
            required: false
        },
        mediaConsent: {
            type: Boolean,
            required: false

        }
    },
    mounted () {
        const cookie = this.$cookies.get('cookiefirst-consent')
        const functional = cookie && cookie.functional
        this.functionalAllowed = functional
    },
    methods: {
        onTagClicked (data) {
            if (this.tagsClickable) {
                this.$emit('tagClicked', data)
            }
        },
        onAddClicked (data) {
            if (this.showAddButton) {
                this.$emit('AddClicked', data)
            }
        },
        buildYoutubeLink (link) {
        // TODO extract to api
            const src = 'https://www.youtube.com/embed/' + link + '?controls=1&rel=0'
            return src
        },
        onOpenClicked (data) {
            if (this.showAddButton) {
                this.$emit('AddClicked', data)
            }
        },
        onRemove () {
            this.$emit('removed', this.shortKey)
        }
    }
}
</script>
